<template>

    <div class="container mt-5">
        <div class="row">
            <div class="col-md-6">
                <div class="card p-4">
                    <div class="card-body">

                        <h2>Сгенерировать ссылку на оплату</h2>

                        <form @submit.prevent="generateLink">

                            <div class="form-group">
                                <label>Номер заказа</label>
                                <input type="text" v-model="data.reference_id" class="form-control" placeholder="Введите номер заказа" required>
                            </div>

                            <div class="form-group">
                                <label>Описание платежа</label>
                                <input type="text" v-model="data.description" class="form-control" placeholder="Введите описание платежа" required>
                            </div>

                            <div class="form-group">
                                <label>Ссылка для перенаправления после оплаты</label>
                                <input type="text" v-model="data.request_url" class="form-control" placeholder="Введите URL адрес" required>
                            </div>

                            <div class="form-group">
                                <label>Сумма платежа</label>
                                <input type="text" v-model="data.amount" class="form-control" placeholder="Введите сумму платежа" required>
                            </div>

                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" v-model="data.user_email" class="form-control" placeholder="Введите email пользователя" required>
                            </div>

                            <div class="checkbox">
                                <label>Тестовый платеж</label><input type="checkbox" v-model="data.is_test">
                            </div>

                            <div class="d-flex justify-content-center mt-3 mb-3">
                                <button type="submit" class="btn btn btn-primary">Получить ссылку</button>
                            </div>
                        </form>

                        <div class="alert alert-danger" v-if="errorText">
                            <span v-text="errorText"></span>
                        </div>

                        <div class="alert alert-info p-4 mt-4" role="alert" v-if="paymentLink">
                            <span v-text="paymentLink"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import bcryptjs from 'bcryptjs';

    export default {
        name: 'DynamicLinkPayin',
        data() {
            return {
                data: {
                    reference_id: '',
                    request_url: '',
                    back_url: '',
                    description: '',
                    amount: 0,
                    user_id: 0,
                    user_email: '',
                    is_test: 1
                },
                paymentLink: '',
                errorText: ''
            }
        },
        computed: {
            ...mapState({
                merchant: state => state.merchant
            })
        },
        mounted() {
            //
        },
        methods: {
            generateLink() {
                this.$store.commit('setLoading');

                this.data.secret_key = bcryptjs.hashSync(this.data.reference_id + this.merchant.secret_key, 10);

                this.data.merchant_id = this.merchant.id;
                this.data.back_url = this.merchant.site_url;
                axios.post('https://api.tarlanpayments.kz/invoice/create', this.data)
                    .then((response) => {
                        if(!response.data.success) {
                            this.errorText = response.data.error.message;
                            this.$store.commit('unsetLoading');
                            return;
                        }

                        this.paymentLink = response.data.data.redirect_url;
                        this.errorText = '';
                        this.$store.commit('unsetLoading');
                    })
                    .catch((error) => {
                        if (error.response != null) {
                            this.errorText = error.response.data.error.message;
                        }
                        this.$store.commit('unsetLoading');
                    });
            }
        }
    }
</script>
<style scoped>

    .checkbox {
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .checkbox p,
    .checkbox input
    {
        vertical-align: middle;
    }

    input[type="checkbox"]{
        width: 25px;
        height: 25px;
    }
</style>
